import React from 'react';
import { Group, Line } from 'react-konva';

// Draw everything in meters - scale is applied at parent Group level
export function WindowRenderer({ window, wall }) {
  if (!window || !wall?.startPoint || !wall?.endPoint) return null;

  // ---------------------------
  // Wall geometry
  // ---------------------------
  const x1 = wall.startPoint.x;
  const y1 = wall.startPoint.y;
  const x2 = wall.endPoint.x;
  const y2 = wall.endPoint.y;

  const dx = x2 - x1;
  const dy = y2 - y1;
  const wallLen = Math.hypot(dx, dy) || 1;

  const ux = dx / wallLen;
  const uy = dy / wallLen;

  // ---------------------------
  // Window placement along wall
  // ---------------------------
  const windowWidth = window.width ?? 1.2; // meters (fallback)

  const offset =
    window.offset !== undefined
      ? window.offset
      : window.position !== undefined
      ? window.position * wallLen
      : wallLen / 2;

  const centerX = x1 + ux * offset;
  const centerY = y1 + uy * offset;

  // ---------------------------
  // Window segment endpoints (along wall)
  // ---------------------------
  const half = windowWidth / 2;

  const segStartX = centerX - ux * half;
  const segStartY = centerY - uy * half;
  const segEndX   = centerX + ux * half;
  const segEndY   = centerY + uy * half;

  // ---------------------------
  // Perpendicular (normal)
  // ---------------------------
  const nx = -uy;
  const ny =  ux;

  // ---------------------------
  // Visual parameters
  // ---------------------------
  const insetFromWall = 0.03; // 3 cm into the room
  const gapBetweenLines = 0.06; // 6 cm total (3 cm each side)
  const halfGap = gapBetweenLines / 2;

  return (
    <Group>
      {/* Inner window line */}
      <Line
        points={[
          segStartX + nx * (insetFromWall - halfGap),
          segStartY + ny * (insetFromWall - halfGap),
          segEndX   + nx * (insetFromWall - halfGap),
          segEndY   + ny * (insetFromWall - halfGap)
        ]}
        stroke="#2196F3"
        strokeWidth={0.2}
        strokeScaleEnabled={false}
        listening={false}
      />

      {/* Outer window line */}
      <Line
        points={[
          segStartX + nx * (insetFromWall + halfGap),
          segStartY + ny * (insetFromWall + halfGap),
          segEndX   + nx * (insetFromWall + halfGap),
          segEndY   + ny * (insetFromWall + halfGap)
        ]}
        stroke="#2196F3"
        strokeWidth={0.2}
        strokeScaleEnabled={false}
        listening={false}
      />
    </Group>
  );
}